"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
  IconButton,
  Typography,
  Autocomplete,
  Box, // Import Box from MUI
} from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"
import BaseURL from "../../api/AppURL";

const EditNsmModal = ({ open, onClose, onUpdateSuccess, nsmId }) => {
  const [nsmanagerName, setNsmanagerName] = useState("")
  const [nsmTeamName, setnsmTeamName] = useState("")
  const [selectedGroup, setSelectedGroup] = useState("") // API এর জন্য group_id
  const [selectedGroupObject, setSelectedGroupObject] = useState(null) // Autocomplete এর জন্য নির্বাচিত গ্রুপ অবজেক্ট
  const [mobileNo, setMobileNo] = useState("")
  const [address, setAddress] = useState("")
  const [groups, setGroups] = useState([])
  const [loadingGroups, setLoadingGroups] = useState(true)
  const [loadingSave, setLoadingSave] = useState(false)
  const [loadingSupplierData, setLoadingSupplierData] = useState(true) // বিদ্যমান সাপ্লায়ার ডেটা লোড করার জন্য
  const [error, setError] = useState(null)

  useEffect(() => {
    if (open) {
      // Modal খোলার সময় ফর্ম এবং মেসেজ রিসেট করুন
      setNsmanagerName("")
      setnsmTeamName("")
      setSelectedGroup("")
      setSelectedGroupObject(null)
      setMobileNo("")
      setAddress("")
      setError(null)
      setLoadingSupplierData(true) // নতুন করে ডেটা লোড করার জন্য
      // fetchGroups()
      if (nsmId) {
        fetchSupplierData(nsmId)
      }
    }
  }, [open, nsmId]) // nsmId পরিবর্তন হলে useEffect আবার চলবে

  // const fetchGroups = async () => {
  //   setLoadingGroups(true)
  //   setError(null)
  //   try {
  //     const token = localStorage.getItem("auth_token")
  //     const response = await axios.get("${BaseURL}/all/supplier", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //       },
  //     })
  //     if (response.data && Array.isArray(response.data.groups)) {
  //       setGroups(response.data.groups)
  //     } else {
  //       setGroups([])
  //       setError("No groups found or invalid response format.")
  //     }
  //   } catch (err) {
  //     console.error("Error fetching groups:", err)
  //     setError("Failed to load groups. Please check your network or API.")
  //   } finally {
  //     setLoadingGroups(false)
  //   }
  // }

  const fetchSupplierData = async (id) => {
    setLoadingSupplierData(true)
    setError(null)
    try {
      const token = localStorage.getItem("auth_token")
      const response = await axios.get(`${BaseURL}/edit/nsmanager/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      const nsManager = response.data.data // API রেসপন্স অনুযায়ী ডেটা অ্যাক্সেস
      if (nsManager) {
        setnsmTeamName(nsManager.nsm_team_name || "")
        setNsmanagerName(nsManager.ns_manager_name || "")
        setMobileNo(nsManager.mobile_no || "")
        setAddress(nsManager.address || "")
        // শুধু group_id সেট করুন। Autocomplete অবজেক্ট পরে useEffect এ সেট হবে।
        setSelectedGroup(nsManager.group_id || "")
        setSelectedGroupObject(null) // Autocomplete অবজেক্ট রিসেট করুন যাতে useEffect আবার কাজ করে
      } else {
        setError("Supplier data not found.")
      }
    } catch (err) {
      console.error("Error fetching nsManager data:", err)
      setError("Failed to load nsManager data for editing.")
    } finally {
      setLoadingSupplierData(false)
    }
  }

  // selectedGroup এবং groups লোড হওয়ার পর selectedGroupObject সেট করার জন্য useEffect
  useEffect(() => {
    if (selectedGroup && groups.length > 0) {
      const group = groups.find((g) => g.id === selectedGroup)
      setSelectedGroupObject(group || null)
    } else if (!selectedGroup) {
      // যদি কোনো গ্রুপ সিলেক্টেড না থাকে, তাহলে Autocomplete এর ভ্যালু null করুন
      setSelectedGroupObject(null)
    }
  }, [selectedGroup, groups]) // selectedGroupObject কে dependency array থেকে সরানো হয়েছে

  const handleUpdate = async () => {
    setLoadingSave(true)
    setError(null)

    const token = localStorage.getItem("auth_token")
    if (!token) {
      setError("Authentication token not found. Please log in again.")
      setLoadingSave(false)
      return
    }

    // Client-side validation for required fields
    if (!nsmTeamName.trim()) {
      setError("Validation Error:\nnsmTeamName is required.")
      setLoadingSave(false)
      return
    }

    if (!nsmanagerName.trim()) {
      setError("Validation Error:\nNSM Name is required.")
      setLoadingSave(false)
      return
    }

    if (!mobileNo.trim()) {
      setError("Validation Error:\nMobile Number is required.")
      setLoadingSave(false)
      return
    }
    if (!address.trim()) {
      setError("Validation Error:\nAddress is required.")
      setLoadingSave(false)
      return
    }

    try {
      const response = await axios.put(
        `${BaseURL}/update/nsmanager/${nsmId}`,
        {
          editnsm_team_name: nsmTeamName,
          editns_manager_name: nsmanagerName,
          editmobile_no: mobileNo,
          editaddress: address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      )

      console.log("API Response on Update:", response.data)

      if (response.data.success === true) {
        onUpdateSuccess(response.data.message || "Supplier updated successfully!")
        onClose()
      } else {
        setError(response.data.message || "Failed to update supplier.")
      }
    } catch (err) {
      console.error("Error updating supplier:", err)
      if (err.response && err.response.data && err.response.data.errors) {
        const validationErrors = Object.values(err.response.data.errors).flat().join("\n")
        setError(`Validation Error:\n${validationErrors}`)
      } else if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message)
      } else {
        setError("An unexpected error occurred while updating the supplier.")
      }
    } finally {
      setLoadingSave(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Edit NSM
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ color: (theme) => theme.palette.grey[500] }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {error && (
          <Alert severity="error" sx={{ mb: 2, whiteSpace: "pre-wrap" }}>
            {error}
          </Alert>
        )}
        {loadingSupplierData ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Loading supplier data...</Typography>
          </Box>
        ) : (
          <>
            <TextField
              label="National Sales Manager Team Name"
              placeholder="National Sales Manager Team Name"
              fullWidth
              margin="normal"
              value={nsmTeamName}
              onChange={(e) => setnsmTeamName(e.target.value)}
              variant="outlined"
              size="small"
            />

            <TextField
              label="National Sales Manager Name"
              placeholder="National Sales Manager Name"
              fullWidth
              margin="normal"
              value={nsmanagerName}
              onChange={(e) => setNsmanagerName(e.target.value)}
              variant="outlined"
              size="small"
            />

          

            <TextField
              label="Mobile No"
              placeholder="Mobile Number"
              fullWidth
              margin="normal"
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
              variant="outlined"
              size="small"
            />
            <TextField
              label="Address"
              placeholder="Enter address"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              variant="outlined"
              size="small"
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button
          variant="contained"
          onClick={handleUpdate}
          disabled={loadingSave || loadingSupplierData}
          sx={{ minWidth: 100 }}
        >
          {loadingSave ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditNsmModal
